/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Ensure hidden media is truly hidden from view and Flickity
  const style = document.createElement('style');
  style.textContent = `
    .media--hidden {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  customElements.whenDefined('product-info').then(() => {
    const ProductInfo = customElements.get('product-info');
    if (ProductInfo && ProductInfo.prototype.filterMedia) {
      const originalFilterMedia = ProductInfo.prototype.filterMedia;
      ProductInfo.prototype.filterMedia = function(sku) {
        const slider = this.querySelector('[data-product-single-media-slider]');
        const thumbs = this.querySelector('[data-product-single-media-thumbs]');
        
        const flkty = (window.theme.Flickity && window.theme.Flickity.data) ? window.theme.Flickity.data(slider) : this.flkty;
        const flktyNav = (window.theme.Flickity && window.theme.Flickity.data) ? window.theme.Flickity.data(thumbs) : this.flktyNav;

        if (flkty) {
          flkty.options.cellSelector = '[data-product-single-media-wrapper]:not(.media--hidden)';
        }
        if (flktyNav) {
          flktyNav.options.cellSelector = '.product-single__thumbnail:not(.media--hidden)';
        }

        // Call original filtering logic
        originalFilterMedia.call(this, sku);

        // Sync media--hidden class to thumbnails (original logic uses style.display)
        this.querySelectorAll('.product-single__thumbnail').forEach(t => {
          t.classList.toggle('media--hidden', t.style.display === 'none');
        });

        // Reload cells for both to ensure they respect the new visibility
        if (flkty && typeof flkty.reloadCells === 'function') {
          flkty.reloadCells();
          if (typeof flkty.setGallerySize === 'function') flkty.setGallerySize();
          
          // Ensure we are not on a hidden slide
          if (flkty.selectedElement && flkty.selectedElement.classList.contains('media--hidden')) {
            flkty.select(0);
          }
        }

        if (flktyNav && typeof flktyNav.reloadCells === 'function') {
          flktyNav.reloadCells();
          if (typeof flktyNav.setGallerySize === 'function') flktyNav.setGallerySize();
        }
      };
    }

    if (ProductInfo && ProductInfo.prototype.updateMedia) {
      const originalUpdateMedia = ProductInfo.prototype.updateMedia;
      ProductInfo.prototype.updateMedia = function(media) {
        // Call original logic first to handle all other updates
        originalUpdateMedia.call(this, media);

        if (!media) return;
        
        const slider = this.querySelector('[data-product-single-media-slider]');
        const flkty = (window.theme.Flickity && window.theme.Flickity.data) ? window.theme.Flickity.data(slider) : this.flkty;
        
        if (flkty && flkty.isActive && flkty.cells) {
          const cellElement = slider.querySelector(`[data-id="${media.id}"]`);
          if (cellElement && !cellElement.classList.contains('media--hidden')) {
            // Find the correct index among currently visible cells
            const correctIndex = flkty.cells.findIndex(cell => cell.element === cellElement);
            if (correctIndex > -1 && correctIndex !== flkty.selectedIndex) {
              flkty.select(correctIndex);
            }
          }
        }
      };
    }

    // Trigger filter on load for the selected or first available variant
    const triggerInitialFilter = (el) => {
      if (el.dataset.initialFilterFired) return;
      el.dataset.initialFilterFired = 'true';

      let sku = el.dataset.sku;
      
      if (!sku) {
        const selectedVariantScript = el.querySelector('script[data-selected-variant]');
        if (selectedVariantScript) {
          try {
            const variant = JSON.parse(selectedVariantScript.textContent);
            sku = variant?.sku;
          } catch (e) {}
        }
      }

      if (sku) {
        try {
          el.filterMedia(sku);
        } catch (e) {
          console.warn('Failed to trigger filterMedia on load', e);
        }
      }
    };

    if (ProductInfo) {
      const originalConnectedCallback = ProductInfo.prototype.connectedCallback;
      ProductInfo.prototype.connectedCallback = function() {
        if (originalConnectedCallback) originalConnectedCallback.call(this);
        
        // Use a small delay to ensure child components and Flickity are initialized
        setTimeout(() => triggerInitialFilter(this), 100);
      };

      // Also trigger for elements already in the DOM (initial page load)
      document.querySelectorAll('product-info').forEach(el => {
        setTimeout(() => triggerInitialFilter(el), 100);
      });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
